(() => {
  const gczText = (text) => window.GAUCZ_I18N?.[text] ?? text;
  const productRules = {
    'gaucz-easy': {
      parts: [gczText('Plná matrace 1'), gczText('Plná matrace 2'), 'TILO 1', 'TILO 2'],
      custom: true,
      uniformProperty: true,
      priceParts: [gczText('Plná matrace 1'), gczText('Plná matrace 2')],
      premiumThreshold: 1,
      helperPricing: true,
      mainLabel: gczText('Barva celé sestavy')
    },
    'gaucz-family': {
      parts: [gczText('Plná matrace 1'), gczText('Plná matrace 2'), gczText('Matrace s otvory'), 'TILO 1', 'TILO 2', 'TILO 3', 'TILO 4'],
      custom: true,
      uniformProperty: true,
      priceParts: [gczText('Plná matrace 1'), gczText('Plná matrace 2'), gczText('Matrace s otvory')],
      premiumThreshold: 2,
      helperPricing: true,
      mainLabel: gczText('Barva celé sestavy')
    },
    'gaucz-solo': {
      parts: [gczText('Hlavní matrace'), 'TILO'],
      custom: true,
      priceParts: [gczText('Hlavní matrace')],
      premiumThreshold: 1,
      helperPricing: true,
      mainLabel: gczText('Barva celé sestavy')
    },
    'gaucz-solo-easy': { parts: [gczText('Barva celé sestavy')], mainLabel: gczText('Barva celé sestavy'), pricedPremium: true },
    maki: { parts: [gczText('Kolo 1')], sets: [1, 2, 3, 5] },
    tilo: {
      parts: [gczText('Barva celého dílu')],
      priceParts: [gczText('Barva celého dílu')],
      premiumThreshold: 1,
      helperPricing: true,
      mainLabel: gczText('Barva dílu')
    },
    lino: {
      parts: [gczText('Barva celého dílu')],
      priceParts: [gczText('Barva celého dílu')],
      premiumThreshold: 1,
      helperPricing: true,
      mainLabel: gczText('Barva dílu')
    },
    vela: {
      parts: [gczText('Barva celého dílu')],
      priceParts: [gczText('Barva celého dílu')],
      premiumThreshold: 1,
      helperPricing: true,
      mainLabel: gczText('Barva dílu')
    },
    arko: { parts: [gczText('Barva celého dílu')], mainLabel: gczText('Barva dílu'), pricedPremium: true },
    rulo: { parts: [gczText('Barva celého dílu')], mainLabel: gczText('Barva dílu'), pricedPremium: true }
  };

  const money = (cents) => new Intl.NumberFormat(window.GAUCZ_LOCALE === 'de' ? 'de-DE' : 'cs-CZ', {
    style: 'currency', currency: window.GAUCZ_CURRENCY || 'CZK', maximumFractionDigits: (window.GAUCZ_CURRENCY || 'CZK') === 'CZK' ? 0 : 2
  }).format(cents / 100);

  const normalizeTier = (value) => String(value || '').toLowerCase().includes('premium') ? 'premium' : 'standard';
  const extractSet = (variant) => Number(String(variant.option1 || variant.title || '').match(/\d+/)?.[0] || 1);

  const init = (scope = document) => {
    scope.querySelectorAll('[data-gaucz-configurator]').forEach((root) => {
      if (root.dataset.gauczReady === 'true') return;

      const handle = root.dataset.productHandle;
      const rule = productRules[handle];
      const form = root.closest('form[action*="/cart/add"]');
      const colorNode = root.querySelector('[data-gaucz-color-config]');
      const variantNode = root.querySelector('[data-gaucz-variants]');
      const helperVariantNode = root.querySelector('[data-gaucz-helper-variant]');
      if (!rule || !form || !colorNode || !variantNode) {
        root.dataset.gauczInitError = 'missing-required-data';
        return;
      }

      const colorData = JSON.parse(colorNode.textContent);
      const variants = JSON.parse(variantNode.textContent);
      const helperVariant = helperVariantNode ? JSON.parse(helperVariantNode.textContent) : null;
      const colors = colorData
        .filter((color) => color.enabled && color.products.includes(handle))
        .sort((a, b) => a.order - b.order);
      if (!colors.length) {
        root.dataset.gauczInitError = 'no-enabled-colors';
        return;
      }

      root.dataset.gauczReady = 'true';

      const mainLabel = root.querySelector('[data-gaucz-main-label]');
      const mainLabelText = root.querySelector('[data-gaucz-main-label-text]');
      const mainColor = root.querySelector('[data-gaucz-main-color]');
      const mainFieldset = root.querySelector('[data-gaucz-main-fieldset]');
      const mainGrid = root.querySelector('[data-gaucz-main-swatches]');
      const detailHeading = root.querySelector('[data-gaucz-detail-heading]');
      const detailFieldset = root.querySelector('[data-gaucz-detail-fieldset]');
      const detailGrid = root.querySelector('[data-gaucz-detail-swatches]');
      const currentColor = root.querySelector('[data-gaucz-current-color]');
      const selectionLabel = root.querySelector('[data-gaucz-selection-label]');
      const currentTier = root.querySelector('[data-gaucz-current-tier]');
      const availability = root.querySelector('[data-gaucz-availability]');
      const partWrap = root.querySelector('[data-gaucz-parts]');
      const customWrap = root.querySelector('[data-gaucz-custom-wrap]');
      const customInput = root.querySelector('[data-gaucz-custom]');
      const setWrap = root.querySelector('[data-gaucz-set-wrap]');
      const setSelect = root.querySelector('[data-gaucz-set]');
      const setSegments = root.querySelector('[data-gaucz-set-segments]');
      const summaryPrice = root.querySelector('[data-gaucz-summary-price]');
      const properties = root.querySelector('[data-gaucz-properties]');
      const confirmation = root.querySelector('[data-gaucz-confirmation]');
      const error = root.querySelector('[data-gaucz-error]');
      const price = form.querySelector('[data-gaucz-price-value]');
      const variantInput = form.querySelector('input[name="id"]');
      const submit = form.querySelector('[data-gaucz-submit]');

      const baseParts = [...rule.parts];
      const requestedVariantId = new URLSearchParams(window.location.search).get('variant');
      const requestedVariant = variants.find((variant) => String(variant.id) === requestedVariantId);
      const requestedTier = requestedVariant && (handle === 'maki' || rule.pricedPremium)
        ? normalizeTier(handle === 'maki' ? requestedVariant.option2 || requestedVariant.title : requestedVariant.option1 || requestedVariant.title)
        : null;
      // Campaign links select an enabled, real colour before pricing and gallery init.
      const requestedColorKey = new URLSearchParams(window.location.search).get('gcz_color');
      const initialColor = colors.find((color) => color.key === requestedColorKey)
        || colors.find((color) => color.tier === requestedTier) || colors[0];
      let selectedSet = handle === 'maki' && requestedVariant && rule.sets.includes(extractSet(requestedVariant))
        ? extractSet(requestedVariant)
        : 1;
      let parts = handle === 'maki'
        ? Array.from({ length: selectedSet }, (_, index) => `${gczText('Kolo')} ${index + 1}`)
        : [...baseParts];
      let activePart = parts[0];
      let custom = false;
      let uniformKey = initialColor.key;
      let choices = Object.fromEntries(parts.map((part) => [part, uniformKey]));

      const colorByKey = (key) => colors.find((color) => color.key === key) || colors[0];
      const selectedColor = (part) => colorByKey(choices[part]);
      const selectedColors = () => parts.map(selectedColor);
      const premiumCount = () => selectedColors().filter((color) => color.tier === 'premium').length;
      const computedTier = () => {
        if (handle === 'maki') {
          const threshold = { 1: 1, 2: 2, 3: 2, 5: 3 }[selectedSet];
          return premiumCount() >= threshold ? 'premium' : 'standard';
        }
        if (rule.priceParts) {
          const drivingPremiumCount = rule.priceParts.filter((part) => selectedColor(part).tier === 'premium').length;
          return drivingPremiumCount >= rule.premiumThreshold ? 'premium' : 'standard';
        }
        return premiumCount() > 0 ? 'premium' : 'standard';
      };

      const findVariant = (tier) => {
        if (handle === 'maki') {
          return variants.find((variant) => extractSet(variant) === selectedSet && normalizeTier(variant.option2 || variant.title) === tier);
        }
        if (rule.pricedPremium) {
          return variants.find((variant) => normalizeTier(variant.option1 || variant.title) === tier);
        }
        if (rule.helperPricing && tier === 'premium') return helperVariant;
        return variants[0];
      };

      const paletteButton = (color, index, palette, selectedKey, disabled) => {
        const button = document.createElement('button');
        const selected = color.key === selectedKey;
        button.type = 'button';
        button.className = 'gcz-configurator__swatch';
        button.dataset.colorKey = color.key;
        button.dataset.gauczPalette = palette;
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', String(selected));
        button.setAttribute('aria-disabled', String(disabled || !color.enabled));
        button.setAttribute('aria-label', color.name);
        button.disabled = disabled || !color.enabled;
        button.tabIndex = selected && !button.disabled ? 0 : -1;
        button.innerHTML = `<img class="gcz-configurator__swatch-image" src="${color.asset}" alt="" width="50" height="50"><span>${color.name}</span>`;

        const choose = () => {
          if (button.disabled) return;
          if (palette === 'main') {
            uniformKey = color.key;
            parts.forEach((part) => { choices[part] = color.key; });
          } else {
            choices[activePart] = color.key;
          }
          render();
        };

        button.addEventListener('click', choose);
        button.addEventListener('keydown', (event) => {
          const directions = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: 5, ArrowUp: -5 };
          if (!(event.key in directions) && event.key !== ' ' && event.key !== 'Enter') return;
          event.preventDefault();
          if (event.key === ' ' || event.key === 'Enter') {
            choose();
            const grid = palette === 'main' ? mainGrid : detailGrid;
            grid.querySelector(`[data-color-key="${color.key}"]`)?.focus();
            return;
          }
          const nextIndex = (index + directions[event.key] + colors.length) % colors.length;
          const nextColor = colors[nextIndex];
          if (palette === 'main') {
            uniformKey = nextColor.key;
            parts.forEach((part) => { choices[part] = nextColor.key; });
          } else {
            choices[activePart] = nextColor.key;
          }
          render();
          const grid = palette === 'main' ? mainGrid : detailGrid;
          grid.querySelector(`[data-color-key="${nextColor.key}"]`)?.focus();
        });
        return button;
      };

      const renderPalettes = () => {
        const isMaki = handle === 'maki';
        mainLabel.hidden = isMaki;
        mainFieldset.hidden = isMaki;
        mainLabelText.textContent = rule.mainLabel || gczText('Barva celé sestavy');
        mainColor.textContent = colorByKey(uniformKey).name;
        mainFieldset.classList.toggle('is-muted', custom);
        mainFieldset.setAttribute('aria-disabled', String(custom));
        mainGrid.innerHTML = '';
        colors.forEach((color, index) => mainGrid.append(paletteButton(color, index, 'main', uniformKey, custom)));

        const showDetail = isMaki || (rule.custom && custom);
        detailHeading.hidden = !showDetail;
        detailFieldset.hidden = !showDetail;
        detailHeading.textContent = isMaki ? gczText('Barva aktivního kola') : gczText('Barva aktivního dílu');
        detailGrid.setAttribute('aria-label', detailHeading.textContent);
        detailGrid.innerHTML = '';
        if (showDetail) {
          const selectedKey = selectedColor(activePart).key;
          colors.forEach((color, index) => detailGrid.append(paletteButton(color, index, 'detail', selectedKey, false)));
        }
      };

      const renderParts = () => {
        const shouldShow = handle === 'maki' || (rule.custom && custom);
        partWrap.hidden = !shouldShow;
        partWrap.innerHTML = '';
        if (!shouldShow) return;
        parts.forEach((part) => {
          const color = selectedColor(part);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'gcz-configurator__part';
          button.setAttribute('aria-pressed', String(part === activePart));
          button.innerHTML = `<span class="gcz-configurator__part-name">${part}</span><img class="gcz-configurator__part-swatch" src="${color.asset}" alt="" width="36" height="36"><strong class="gcz-configurator__part-color">${color.name}</strong>`;
          button.addEventListener('click', () => {
            activePart = part;
            render();
            detailGrid.querySelector(`[data-color-key="${selectedColor(part).key}"]`)?.focus();
          });
          partWrap.append(button);
        });
      };

      const addProperty = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${name}]`;
        input.value = value;
        properties.append(input);
      };

      const update = () => {
        const tier = computedTier();
        const premiumUnknown = tier === 'premium' && handle !== 'maki' && !rule.pricedPremium && !rule.helperPricing;
        const variant = findVariant(tier);
        const uniformColor = colorByKey(uniformKey);
        currentTier.textContent = tier === 'premium' ? gczText('Prémiová') : gczText('Základní');
        availability.textContent = variant?.available ? gczText('Dostupné') : gczText('Dočasně nedostupné');

        if (handle === 'maki') {
          selectionLabel.textContent = gczText('Vybraná konfigurace');
          currentColor.textContent = parts.map((part) => `${part}: ${selectedColor(part).name}`).join(' · ');
        } else if (custom) {
          selectionLabel.textContent = gczText('Vybraná kombinace');
          currentColor.textContent = parts.map((part) => `${part}: ${selectedColor(part).name}`).join(' · ');
        } else {
          selectionLabel.textContent = gczText('Vybraná barva');
          currentColor.textContent = uniformColor.name;
        }

        properties.innerHTML = '';
        if (handle === 'gaucz-solo') {
          addProperty(gczText('Hlavní matrace'), selectedColor(gczText('Hlavní matrace')).name);
          addProperty('TILO', selectedColor('TILO').name);
          addProperty(gczText('Cenová hladina'), tier === 'premium' ? gczText('Prémiová') : gczText('Základní'));
        } else {
          if (rule.uniformProperty && !custom) addProperty(gczText('Barva celé sestavy'), uniformColor.name);
          parts.forEach((part) => addProperty(part, selectedColor(part).name));
          addProperty(gczText('Cenová hladina'), tier === 'premium' ? gczText('Prémiová') : gczText('Základní'));
        }
        if (handle === 'maki') addProperty(gczText('Počet kol'), String(selectedSet));

        confirmation.hidden = !premiumUnknown;
        error.hidden = true;
        if (premiumUnknown) {
          availability.textContent = gczText('Cena vyžaduje potvrzení');
          summaryPrice.textContent = gczText('Cena na potvrzení');
          if (price) price.textContent = gczText('Cena na potvrzení');
          if (submit) {
            submit.disabled = true;
            submit.textContent = gczText('Cena na potvrzení');
          }
          return;
        }

        if (!variant) {
          summaryPrice.textContent = gczText('Cena není dostupná');
          error.textContent = gczText('Tuto konfiguraci se nepodařilo nacenit. Kontaktujte nás prosím.');
          error.hidden = false;
          if (submit) submit.disabled = true;
          return;
        }

        variantInput.value = variant.id;
        summaryPrice.textContent = money(variant.price);
        if (price) price.textContent = money(variant.price);
        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available ? `${gczText('Přidat do košíku')} · ${money(variant.price)}` : gczText('Dočasně nedostupné');
        }
      };

      const syncSetControls = () => {
        setSelect.value = String(selectedSet);
        setSegments.querySelectorAll('[data-gaucz-set-value]').forEach((button) => {
          const selected = Number(button.dataset.gauczSetValue) === selectedSet;
          button.setAttribute('aria-checked', String(selected));
          button.tabIndex = selected ? 0 : -1;
        });
      };

      const applySet = (value) => {
        selectedSet = Number(value);
        const previous = { ...choices };
        parts = Array.from({ length: selectedSet }, (_, index) => `${gczText('Kolo')} ${index + 1}`);
        choices = Object.fromEntries(parts.map((part) => [part, previous[part] || uniformKey]));
        activePart = parts[0];
        syncSetControls();
        render();
      };

      const render = () => {
        renderParts();
        renderPalettes();
        update();
      };

      if (rule.custom) {
        customWrap.hidden = false;
        customInput.addEventListener('change', (event) => {
          event.stopPropagation();
          custom = customInput.checked;
          if (!custom) {
            parts.forEach((part) => { choices[part] = uniformKey; });
            activePart = parts[0];
          }
          render();
        });
      }

      if (handle === 'maki') {
        setWrap.hidden = false;
        setSegments.hidden = false;
        setSelect.setAttribute('aria-hidden', 'true');
        setSelect.tabIndex = -1;
        setSelect.addEventListener('change', (event) => {
          event.stopPropagation();
          applySet(setSelect.value);
        });
        setSegments.querySelectorAll('[data-gaucz-set-value]').forEach((button, index, buttons) => {
          button.addEventListener('click', () => applySet(button.dataset.gauczSetValue));
          button.addEventListener('keydown', (event) => {
            if (!['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].includes(event.key)) return;
            event.preventDefault();
            const direction = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
            const next = buttons[(index + direction + buttons.length) % buttons.length];
            applySet(next.dataset.gauczSetValue);
            next.focus();
          });
        });
        syncSetControls();
      }

      form.addEventListener('submit', (event) => {
        if (!error.hidden || !confirmation.hidden) {
          event.preventDefault();
          if (!error.hidden) error.focus();
        }
      });

      render();
    });
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
